enum CompanyMarketplaceAccessType {
  ALL = "all",
  DISABLED = "disabled",
  SELECTED = "selected",
}

export default CompanyMarketplaceAccessType;